import React from 'react';
import { connect } from 'react-redux';
import { setMyDepartmentsColumns } from '../../../../../store/actions';
import { Page } from '../../../../../constants/constants';
import GridActionHeader from '../../../../shared/GridActionHeader/GridActionHeader';

class ActionsHeader extends React.Component {

    render() {
        const { rowDetail, columnsDef } = this.props;

        return (
            <GridActionHeader
                page={Page.myDepartments}
                setColumns={columns => this.props.setMyDepartmentsColumns(columns)}
                columnsToShow={this.props.columnsToShow}
                columnsDef={columnsDef}
                rowDetail={rowDetail}
            />
        );
    }
};

const mapStateToProps = state => ({
    columnsToShow: state.mydepartments.columns
})

const mapDispatchToProps = {
    setMyDepartmentsColumns
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsHeader);
